import app, {AppState} from "@/store/modules/app";
import user, {UserState} from "@/store/modules/user";
import permission, {PermissionState} from "@/store/modules/permission";
import Vue from 'vue'
import Vuex, {Store} from 'vuex'
import setting,{SettingState} from "@/store/modules/setting";

Vue.use(Vuex);

export interface AppRootState {
  app: AppState,
  user: UserState,
  permission: PermissionState,
  setting:SettingState
}


export default new Store<AppRootState>({
  state: {} as AppRootState,
  mutations: {},
  modules: {
    app: app,
    user: user,
    permission: permission,
    setting:setting
  }
})

